export default "__VITE_ASSET__CCfKz9TU__"